import { all, put } from "redux-saga/effects";

import { actions as messagingActions } from "~/messaging";
import { actions as notificationActions, MSGTYPE } from "~/notifications";

import { messages } from "../i18n-messages";

interface IDefinedLegendSurfaceDefaultNotAddedMessage {
    ownerDefinedLegendGuid: string;
}

const messageSubscriptions = function* () {
    yield put(
        messagingActions.subscribe(0, {
            eventName: "surfaceDefaultNotAdded",
            action: (message: IDefinedLegendSurfaceDefaultNotAddedMessage) =>
                notificationActions.pushToasterMessage(
                    messages.surfaceDefaultNotAdded,
                    MSGTYPE.ERROR,
                    { ownerDefinedLegendGuid: message.ownerDefinedLegendGuid }
                ),
        })
    );
};

const DefinedLegendSagas = function* () {
    yield all([messageSubscriptions()]);
};

export default DefinedLegendSagas;
